/* eslint-disable max-lines-per-function */
import type { JSX } from 'react';
import { useState } from 'react';
import { Label } from '@/components/ui/label';
import { TagInput } from '@/components/ui/tag-input';
import { useJobPositionSuggestions } from '../../hooks/useJobPositionSuggestions';
import type { FormSectionProps } from './types';

export function RequirementsSection({
  register,
  errors,
  setValue,
  watch,
}: FormSectionProps): JSX.Element {
  const languages = watch('languages') || [];
  const certifications = watch('certifications') || [];

  const [languagesQuery, setLanguagesQuery] = useState('');
  const [certificationsQuery, setCertificationsQuery] = useState('');

  const { data: languagesSuggestions } = useJobPositionSuggestions('languages', languagesQuery);
  const { data: certificationsSuggestions } = useJobPositionSuggestions(
    'certifications',
    certificationsQuery
  );

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Additional Requirements</h3>
      <div className="space-y-2">
        <Label>Languages</Label>
        <TagInput
          value={languages}
          onChange={(value) => setValue('languages', value)}
          placeholder="Add languages..."
          suggestions={languagesSuggestions}
          onQueryChange={setLanguagesQuery}
        />
        {errors.languages && <p className="text-sm text-red-500">{errors.languages.message}</p>}
      </div>
      <div className="space-y-2">
        <Label>Certifications</Label>
        <TagInput
          value={certifications}
          onChange={(value) => setValue('certifications', value)}
          placeholder="Add certifications..."
          suggestions={certificationsSuggestions}
          onQueryChange={setCertificationsQuery}
        />
        {errors.certifications && (
          <p className="text-sm text-red-500">{errors.certifications.message}</p>
        )}
      </div>
      <div className="space-y-2">
        <Label htmlFor="requirements">Job Requirements</Label>
        <textarea
          id="requirements"
          {...register('requirements')}
          className="flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-xs focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="responsibilities">Responsibilities</Label>
        <textarea
          id="responsibilities"
          {...register('responsibilities')}
          className="flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-xs focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
        />
      </div>
    </div>
  );
}
